import { useQuery } from '@tanstack/react-query';
import { PkDialog } from '@uefadigital/panenka-react';
import { lazy, memo, Suspense, useMemo, useState } from 'react';

import HospitalityCategoryPackage from '../Category';
import type { HospitalityOptions } from '../types';

import type { EditorialContent } from '@cobalt/utilities';
import { getTicketInfo } from '@cobalt/utilities';
import { useWindowSize } from '@hooks/useWindowSize';
import { getEditorialsQuery } from '@queries/editorial';
import ReactPortal from '@shared/ReactPortal';
import { language } from '@utilities/browser';
import { competitionId, currentSeason } from '@utilities/WindowContext';

import * as css from './styles.module.scss';

const HospitalityCategory = lazy(() => import('./CategoryCard'));

const HospitalityCategoryies = ({ options }: { options: HospitalityOptions }) => {
  const [articleId, setArticleId] = useState('');
  const { isDesktop } = useWindowSize();

  const ticketFilters = useMemo(
    () => ({
      type: 'ticket',
      'param.attributes.competitions': competitionId,
      'param.attributes.language': language,
      'param.attributes.main.season': currentSeason,
      'param.attributes.main.kind': options.kind,
      'param.attributes.sections': options.section,
      'param.attributes.footballEntities.venue.venueId': options.venueId,
      aggregator: 'lightnodejson',
    }),
    [options],
  );

  const { data: tickets, isLoading } = useQuery({
    ...getEditorialsQuery(ticketFilters),
    select: (data) =>
      data?.sort((a, b) => {
        const priceA = parseFloat(getTicketInfo(a)?.ticketPrice) || 0;
        const priceB = parseFloat(getTicketInfo(b)?.ticketPrice) || 0;
        return priceB - priceA;
      }),
  });

  const handleClick = (article: EditorialContent) => {
    setArticleId(article.id);
  };
  const handleClose = () => {
    setArticleId('');
  };
  return (
    <>
      <div
        className='pk-d--flex pk-flex--wrap pk-flex-md--wrap pk-justify-content--center pk-gap--l'
        id='hospitality-categoryies-list'
      >
        {!isLoading &&
          tickets?.map((ticket) => (
            <Suspense key={ticket.id} fallback={<div>Loading category...</div>}>
              <HospitalityCategory
                articleId={ticket.id}
                onButtonClick={handleClick}
                showFromText={false} // this option will be implemented in Phase3 to show/hide the from label in the price in case of more tickets per same category
                sitsTextFromCms={options.sitsTextFromCms}
              />
            </Suspense>
          ))}
      </div>
      <ReactPortal>
        <div className={css.dialog}>
          <PkDialog
            isOpen={!!articleId}
            onPkClose={handleClose}
            size={isDesktop ? 'large' : 'full'}
            pk-theme='light'
            width={isDesktop ? 700 : ''}
          >
            <div slot='body'>
              <div className='pk-position--absolute pk-w--100 pk-px--m pk-px-sm--xl2 pk-pb--l'>
                <HospitalityCategoryPackage articleId={articleId} />
              </div>
            </div>
          </PkDialog>
        </div>
      </ReactPortal>
    </>
  );
};

export default memo(HospitalityCategoryies);
